module.exports = __webpack_public_path__ + "media/images/top-page_reserve_sp@1x-9cdae2ea5c75ef8157fc8a5b0b7a0baf.jpg";